<script>
import { focus } from 'vue-focus';

export default {
  name: 'KeyboardBox',
  props: {
    value: { },
  },
  directives: {
    focus,
  },
  data: () => ({
    isInputFocused: true,
  }),
  watch: {
    '$route.name' () {
      if (this.$route.meta.realName === 'games-search') {
        this.isInputFocused = true;
      }
    },
    isInputFocused () {
      if (this.$route.meta.realName === 'games-search') {
        this.isInputFocused = true;
      }
    },
  },
  methods: {
    onKeyboardTrigger ({ value, type }) {
      let newSearch;
      let doNothing;
      if (type === 'input') {
        newSearch = `${this.value}${value}`;
      } else if (type === 'action') {
        switch (value) {
        case 'bksp':
          newSearch = this.value.slice(0, -1);
          break;
        case 'space':
          newSearch = `${this.value} `;
          break;
        default:
          doNothing = true;
        }
      }
      if (!doNothing) this.emitInput(newSearch);
    },
    emitInput (value) {
      this.$emit('input', value);
    },
    clearSearch () {
      this.emitInput('');
    },
  },
};
</script>

<template lang="pug">
div.keyboard-box
  div.relative._collision.mb2
    clear-style
      transition(enter-active-class="fadeIn animated-200", leave-active-class="fadeOut animated-200")
        button.f7.absolute.right-0.z-1.top-0.h-100.no-underline.green.pl3(type="button", @click="clearSearch", v-if="value")
          span.v-mid {{ $t('Clear search') }}
          icon.w1.fill-inherit.v-mid.mh2(name="x")
    input-style
      input.pa3.f4.br0.w-100.ttu(type="search", :placeholder="$t('Enter your search')", :value="value", v-focus="isInputFocused", @blur="isInputFocused = false", @focus="isInputFocused = true", @input="emitInput($event.target.value)")
  keyboard-with-provider.keyboard.bg-black-overlay.relative._collision(
    :layout="$i18n.locale"
    :lang="$i18n.locale",
    defaultLayout="en-US",
    @trigger="onKeyboardTrigger",
    :classnames=`{
      wrapper: 'wrapper',
      row: 'row center tc',
      key: 'key h-green white f4 ttu',
    }`,
  )
    span(slot="action:shift", slot-scope="{ args }") ⇧
    span(slot="action:enter", slot-scope="{ args }") ↵
    span(slot="action:bksp", slot-scope="{ args }") ⌫
    span(slot="action:numbers", slot-scope="{ args }") 123?
    span.db.bg-white.w5.br2.h1(slot="action:space", slot-scope="{ args }")
    span(slot="action:tab", slot-scope="{ args }") ⇥

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";
.keyboard-box {
}
</style>
<style>
@import "styles/variables.css";
.keyboard-box {
  & .key:active,
  & .key.-active {
    background-color: var(--green);
    color: black;
  }
  & .key {
    padding: 1.4rem;
  }
}
</style>
